import scrollToElement from '@/utils/scrollToElement.utils';
import type { ComponentOptionsMixin } from 'vue';

const scrollToIdMixin: ComponentOptionsMixin = {
  name: 'scroll-to-id',
  methods: {
    scrollToId(id: string, opts: Record<string, unknown> = {}, options = { useUrlFragment: true }) {
      const element = document.getElementById(id);
      if (element) {
        scrollToElement(element, opts);
      }
      if (options.useUrlFragment) {
        window.history.pushState(null, '', `#${options.useUrlFragment}`);
      }
    },
  },
};
export default scrollToIdMixin;
